import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
import { PricingSelector } from './PricingSelector';
export function PricingUrgency() {
  return <section id="pricing" className="py-10 md:py-20 px-4 sm:px-6 lg:px-8 bg-cream" data-id="element-219">
      <div className="max-w-5xl mx-auto" data-id="element-220">
        {/* Urgency Banner — compact */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-red-50 border border-red-200 rounded-xl md:rounded-2xl p-3 md:p-4 text-center mb-6 md:mb-10 max-w-3xl mx-auto relative overflow-hidden" data-id="element-221">
          <div className="absolute top-0 left-0 w-1 h-full bg-red-500" data-id="element-222"></div>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 md:gap-3" data-id="element-223">
            <motion.div animate={{
            scale: [1, 1.1, 1]
          }} transition={{
            repeat: Infinity,
            duration: 2
          }} className="bg-red-100 p-1.5 md:p-2 rounded-full text-red-600 flex-shrink-0" data-id="element-224">
              <Clock className="w-4 h-4 md:w-5 md:h-5" data-id="element-225" />
            </motion.div>
            <div className="text-center sm:text-left" data-id="element-226">
              <p className="text-red-900 font-bold text-sm md:text-base" data-id="element-227">
                El precio de lanzamiento termina pronto.
              </p>
              <p className="text-red-700 text-xs md:text-sm" data-id="element-228">
                Después sube $8.000 ARS y no vuelve a bajar.
              </p>
            </div>
          </div>
        </motion.div>

        <div className="text-center mb-6 md:mb-8" data-id="element-229">
          <h2 className="text-2xl md:text-4xl font-bold text-navy mb-1.5 md:mb-3" data-id="element-230">
            ELEGÍ TU KIT PROFESIONAL POSTPARTO
          </h2>
          <p className="text-navy/70 font-medium text-xs md:text-base" data-id="element-231">
            Las dos opciones incluyen los 6 bonos completos
          </p>
        </div>

        <PricingSelector data-id="element-232" />
      </div>
    </section>;
}